<template>
  <div class="lm-container">
    <div class="lm-headline">
      <div>{{ $t('Webportal.CX.Dashboard.Month') }}</div>
      <div>VIN17</div>
      <div>{{ $t('Webportal.CX.TypeOfSale') }}</div>
      <div>{{ $t('Webportal.CX.MarketingApprovalFor') }}</div>
      <div>{{ $t('Webportal.CX.ContactChannel') }}</div>
      <div>{{ $t('Webportal.CX.Rating') }}</div>
    </div>

    <div class="lm-line" v-for="(val, index) in getMonthValue()" :key="index">
      <div>{{ getMonthText(val.Date) }}</div>
      <div>{{ val.Vin17 }}</div>
      <div>{{ val.TypeOfSale }}</div>
      <div>{{ val.MarketingClearance }}</div>
      <div>{{ val.ContactChannel }}</div>
      <div>{{ val.Rating == true ? $t('Webportal.Yes') : val.Rating == false ? $t('Webportal.No') : null }}</div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    card:               { type: Object, default: undefined }
  },

  methods: {
    getMonthText(date) {
      return moment(date).format('MMMM');
    },

    getMonthValue() {
      return this?.card?.details[0]?.monthly;
    }
  }
}
</script>

<style lang="scss" scoped>
  .lm-line, .lm-headline {
    grid-template-columns: 2fr 3fr 3fr 3fr 2fr 2fr;
  }
</style>